import { Identifiable } from '@mews/std';
import { AsyncAction, CommanderThunkAction, WithOwnerId } from '@mews-commander/types';
import {
    Address,
    AddressAddParameters,
    AddressOwnerType,
    MultipleNewAddressUpdateParameters,
} from '@mews-commander/data-access';
import { createFetchAction } from '@mews-commander/utils';
import { ADDRESS_ADD, ADDRESS_DELETE, ADDRESS_UPDATE, getAddress } from '../ducks/addresses';

interface AddAddressProps extends Omit<AddressAddParameters, 'owner'>, WithOwnerId {
    isCompany: boolean;
}

type UpdateAddressProps = Pick<MultipleNewAddressUpdateParameters, 'addressUpdates'> & WithOwnerId;

export const addAddress =
    ({ ownerId, isCompany, ...other }: AddAddressProps): CommanderThunkAction<AsyncAction> =>
    async (dispatch, getState, { repositories }) => {
        const discriminator = isCompany ? AddressOwnerType.Company : AddressOwnerType.Customer;

        const promise = repositories.addresses
            .add({ owner: { discriminator, value: { id: ownerId } }, ...other })
            .then((address) => ({
                ownerId,
                ...address,
            }));
        return dispatch(createFetchAction(ADDRESS_ADD, promise));
    };

export const updateAddress =
    ({ ownerId, addressUpdates }: UpdateAddressProps): CommanderThunkAction<AsyncAction> =>
    async (dispatch, getState, { repositories }) => {
        const promise = repositories.addresses
            .update({ addressUpdates })
            .then(({ addresses }: { addresses: Array<Address> }) => ({ ownerId, ...addresses[0] }));
        return dispatch(createFetchAction(ADDRESS_UPDATE, promise));
    };

export const deleteAddress =
    ({ id }: Identifiable): CommanderThunkAction<AsyncAction> =>
    async (dispatch, getState, { repositories }) => {
        const address = getAddress(getState(), { id });
        const promise = repositories.addresses.delete({ addressIds: [id] }).then(() => address);
        return dispatch(createFetchAction(ADDRESS_DELETE, promise));
    };
